import { EventTrack, EventTrackTypes } from '../constants/EventTracks';
import { StopStatus } from '../constants/Stops';
import { StopReport } from '../domain/report/StopReport';
import { postHogService } from '../services';

interface CaptureCreateReportProps {
  stopReport: StopReport;
  status: StopStatus;
  isOffline: boolean;
  hasLocation: boolean;
  hasCreatedTasks: boolean;
}

export const useCaptureEvents = () => {
  const capture = (eventTrack: EventTrack) => {
    postHogService.capture(eventTrack.type, eventTrack.payload);
  };

  const captureCreateReport = ({
    stopReport,
    status,
    isOffline,
    hasLocation,
    hasCreatedTasks,
  }: CaptureCreateReportProps) => {
    capture({
      type: EventTrackTypes.CreateReport,
      payload: {
        [`Has location`]: hasLocation,
        [`Has signature`]: stopReport.signature ?? false,
        [`Has comments`]: stopReport.comments ?? false,
        [`Has images`]: stopReport.images ?? false,
        [`Has custom fields`]: stopReport.custom_fields ?? false,
        [`Has tasks`]: stopReport.tasks_total > 0 ? true : false,
        [`Has created tasks`]: hasCreatedTasks,
        [`Is offline`]: isOffline,
        [`Status`]: status === `incomplete` ? `Incomplete` : status === `completed` ? `Completed` : `Canceled`,
      },
    });
  };

  return { capture, captureCreateReport };
};
